import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { CarteiraCliente } from '../domain/carteira-cliente.model';

export class CarteiraClienteSerializer extends DomainSerializer<CarteiraCliente> {}
